import React from 'react';
import { FormattedRichMessage, ContentPage, CIAMLinkButton } from 'ciam-self-service-shared';
import Page from 'components/common/Page';
import styled from 'styled-components';
import { Alert } from '@manulife/mux';
import { useIntl } from 'react-intl';
import AnalyticsDataLayer from '../../../common/Analytics';

const Wrapper = styled.div`
  margin: 5rem 0;
`;

const ADD_MOBILE_ERROR_PAGE = 'mobile-number-error';

export default function ErrorPage() {
  const intl = useIntl();
  sessionStorage.removeItem('ciam.addNumberbackButton-otp');
  sessionStorage.removeItem('ciam.addBackupEmailbackButton-otp');
  return (
    <Page title={intl.formatMessage({ id: 'common.error' })}>
      <AnalyticsDataLayer pageName={ADD_MOBILE_ERROR_PAGE} error="AddMobileError" />
      <ContentPage>
        <Alert severity={Alert.SEVERITY.ALERT}>
          <FormattedRichMessage id="signin.addmobile.error.messageCard" />
        </Alert>
        <Wrapper>
          <CIAMLinkButton
            to="/"
            analyticsData={{
              click: {
                linkName: intl.formatMessage({ id: 'signin.addmobile.errorButton' }),
                linkHref: '/',
              },
            }}
          >
            <FormattedRichMessage id="signin.addmobile.errorButton" />
          </CIAMLinkButton>
        </Wrapper>
      </ContentPage>
    </Page>
  );
}
